import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WheelSegment, WheelGenericResponse } from '../models/wheel-of-fortune.model';
import { Observable } from 'rxjs';
import { AppApiUrls } from 'src/app/app.api.urls';
import { BalanceInterface } from 'src/app/pages/profile/interfaces/profile.interface';
import { StorageLogicService } from '../../utils/services/storage-logic.service';

@Injectable({
  providedIn: 'root'
})
export class WheelOfFortuneApiService {

  private http = inject(HttpClient);

  private CITY_ID = inject(StorageLogicService).getData('city');

  public getUserWheelState(): Observable<WheelGenericResponse<{ balance: number; rewards:WheelSegment[]}>> {
    return this.http.get<WheelGenericResponse<{ balance: number; rewards: WheelSegment[] }>>(AppApiUrls.wheelState(), {
      params: {
        city_id: this.CITY_ID
      },
      headers: {
        skipInterceptor:'true'
      }
    })
  }

  public getSpinResult(): Observable<WheelGenericResponse<{ days: number; reward: WheelSegment }>> {
    return this.http.post<WheelGenericResponse<{ days: number; reward: WheelSegment }>>(AppApiUrls.useWheelSpin(),{}, {
      params: {
        city_id: this.CITY_ID,
      },
      headers: {
        skipInterceptor:'true'
      }
    })
    /**DON'T REMOVE 
     return of(mockSpinResponse('product'));
    */
  }

  public buyWheelSpins(req: {spins: number}): Observable<WheelGenericResponse<{ balance: number; bonuses:number }>> {
    return this.http.post<WheelGenericResponse<{ balance: number; bonuses: number }>>(AppApiUrls.buyWheelSpin(), req, {
      params: {
        city_id: this.CITY_ID
      },
      headers: {
        skipInterceptor:'true'
      }
    })

    /**DON'T REMOVE 
    return of({
      data: {
        balance: 2,
        bonuses:24
      },
      success: true
    })
    */
  }

   public getBonusBalance(): Observable<BalanceInterface> {
    return this.http.get<BalanceInterface>(AppApiUrls.bonusBalance(), {
      params: {
        city_id: this.CITY_ID
      },
      headers: {
        skipInterceptor:'true'
      }
    });
  }
}
